import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { SpecificAttribute, specificAttributesType } from '../../types/slices/specificAttributesType'

const initialState: specificAttributesType =
{
    status: ApiStatus.FETCHED,
    specificAttributes: [],
    specificAttributeSelected: {} as SpecificAttribute,
    errorMessage: undefined,
    action: ''
}

const specificAttributesSlice = createSlice({
    name: 'specificAttributesSlice',
    initialState,
    reducers: {
        onFetchSpecificAttributes (state, { payload }: { payload: SpecificAttribute[]}) {
            state.status = ApiStatus.FETCHED
            state.specificAttributes = payload
            state.errorMessage = undefined
        },
        onSetSelectedSpecificAttribute (state, { payload }: { payload: SpecificAttribute }) {
            state.specificAttributeSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSpecificAttributesState = (state: RootState) => state.specificAttributesSlice
export default specificAttributesSlice.reducer
export const {
    onFetchSpecificAttributes,
    onSetSelectedSpecificAttribute,
    changeStatus,
    setAction,
} = specificAttributesSlice.actions
